import React,{ useState, useEffect } from 'react';
import { useSelector, useDispatch} from 'react-redux';
import { Divider, Modal, Loader, Button } from 'rsuite';
import Radio from '@material-ui/core/Radio';
import PaymentIcon from '@material-ui/icons/Payment';
//import * as actionsAuth  from '../../../../../app/actions/auth/auth';
import * as actionsPayment  from '../../../../../app/actions/payment';
import { CheckBoxCustom } from '../../elements/inputFields';
import {PaymentsLogos, ShieldLock, InfoIcon} from '../../svg/iconsSvg';
import {ENV} from '../../../../../envirement';

const CardPayment = ({insuranceId, cashflowId, payAmount, payAmountEUR, onForward}) => {

    const dispatch = useDispatch();

    const state = useSelector(state => state);

    const { paymentCards } = useSelector(state => state.payment);
    
    const [trueData, setTrueData] = useState(true);
    const [saveCard, setSaveCard] = useState(true);
    const [showNoSuccess, setShowNoSuccess] = useState(false);

    const [selectedCard, setSelectedCard] = useState(null);

    const [loading, setLoading]   = useState(false);

    useEffect(()=>{
        const fetchPaymentCards = async () => {
            setLoading(true);
            await dispatch(actionsPayment.getPaymentCards());
            setLoading(false);
        }

        fetchPaymentCards();
    }, [dispatch]);

    const closeModal = () => setTrueData(true);
    const closeModalNoSuccess = () => setShowNoSuccess(false);

    const paymentWithNewCard = async () => {
        setSelectedCard(false);

        let res;

        try { 
            res = await actionsPayment.makePaymentWithNewCard(state, insuranceId, cashflowId, saveCard);
        } 
        catch (error) { console.log(error);}

        if(res?.data && res.data?.messageCode === "WV_REQUIRED" && res.data?.status === 0 && res.data?.payload?.buildUrl) {
            
            console.log(res.data?.payload?.buildUrl);

            //const url = res.data?.payload?.buildUrl;
            const url = (ENV === 'test') ? 'http://127.0.0.1:8080/' : res.data?.payload?.buildUrl;
            window.location.href = url; 
            return null;
        }

    // TO DO
        console.log(res?.data);
    }

    const handleSubmit = async () => {
        //ToDO enable after tests
        //await dispatch(actionsAuth.refreshLoginToken());

        if(!selectedCard) {
           return paymentWithNewCard();
        }

        let res;

        try { 
            res = await actionsPayment.makePaymentWitStoredCard(state, insuranceId, cashflowId, saveCard, selectedCard);
        } 
        catch (error) { console.log(error);}

    // TO DO
        console.log(res?.data);
        if(res?.data && res?.data.status === 0) {
            onForward()
        } else if (res?.data && res?.data.status === 1) {
            setShowNoSuccess(true);
        }
    }
    
    const selectPaymentCard = (card) => {
        setSelectedCard(card);
    }

    const deselectPaymentCard = () => {
        setSelectedCard(null);
    }

    const renderPaymentCards = () => {
        return paymentCards.map((card, i) => {
            return  (
                <div key={i+1}>
                    <div className="steps_container-checkbox" style={{alignItems: 'start', paddingLeft: '23px'}}>
                        <Radio
                            checked={card?.maskedPan === selectedCard?.maskedPan}
                            onChange={()=>selectPaymentCard(card)}
                            value=""
                            name="radio-buttons"
                            inputProps={{ 'aria-label': 'B'+ i }}
                            />
                        <div style={{margin: '8px 0'}}>
                            <p>{card?.maskedPan}</p>
                            <p>{card?.expiryDate}</p>
                        </div>
                    </div>
                    <Divider />
                </div>)
        }) 
    }

    return (
        <>
            <div className="payment-card">
                <div className="left">
                    <p style={{marginBottom: '8px'}}>Плащане с карта</p>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
                        <ShieldLock />
                        <PaymentsLogos />
                    </div>
                </div>
                <div className="right">
                <p style={{marginBottom: '8px', opacity: '.7'}}>Сума за плащане</p>
                <p style={{fontWeight: '700', fontSize: '15px', paddingLeft: '8px'}}>{payAmountEUR} € / {payAmount} лв.</p>
                </div>
            </div>
            {paymentCards?.length 
                ? <div className="payment-cards"> 
                    <div className="title" style={{marginTop: '20px'}}>
                        <PaymentIcon style={{color: "#5cd2aa"}} />
                        <p >Карти</p>
                    </div>
                    <Divider />
                    {renderPaymentCards()}
                    <div className="steps_container-checkbox"  style={{cursor: 'pointer', paddingLeft: '23px'}} onClick={()=>{}}>
                        <Radio
                            checked={!selectedCard}
                            onChange={()=>deselectPaymentCard()}
                            value=""
                            name="radio-buttons"
                            inputProps={{ 'aria-label': 'new' }}
                            />
                        <h6 style={{marginLeft: '10px', fontWeight: '500'}}>Плати с друга карта</h6>
                    </div>
                    <Divider />
                 </div>
                : <div style={{marginBottom: '20px'}}></div>}
            
            <div className="steps_container-checkbox" >
                <InfoIcon size={20} />
                <p style={{opacity: '.7'}}>Nu Ins не съхранява чувствителни данни за твоята карта</p>
            </div>

            <div className="steps_container-checkbox" style={{marginBottom: '20px', marginTop: '20px'}}>
                <CheckBoxCustom onChange={(data)=>setSaveCard(data)} value={saveCard}/>
                <p>Искам да запазя картата за следващо плащане</p>
            </div>

            <div className="steps_container-checkbox" style={{marginBottom: '20px'}}>
                <CheckBoxCustom onChange={(data)=>setTrueData(data)} value={trueData}/>
                <p>Декларирам верността на подадените данни</p>
            </div>

            <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" onClick={()=>handleSubmit()}>{selectedCard ? 'Плащане с карта' : 'Плати с друга карта'}</button>

            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}

            {/* Modal for true data */}
            <Modal size="xs" show={!trueData} className="nuins-ok-modal" onHide={() => closeModal()}>
                <Modal.Body >
                    <p className="no-reg-data">Не може да подадете данни с невярно съдържание</p>    
                </Modal.Body>
                <Modal.Footer >
                    <Button onClick={() => closeModal()} >OK</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal for unsuccessfull payment */}
            <Modal size="xs" show={showNoSuccess} className="nuins-ok-modal" onHide={() => closeModalNoSuccess()}>
                <Modal.Body >
                    <p className="no-reg-data">Плащането не беше успешно, моля опитайте с друга карта</p>    
                </Modal.Body>
                <Modal.Footer >
                    <Button onClick={() => closeModalNoSuccess()} >OK</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default CardPayment;

//<CirclePlusIcon size={22} />